import isReadOnlyModeEnabled from './is-read-only-mode-enabled';

export default {
  isReadOnlyModeEnabled,
};
